import "bootstrap-icons/font/bootstrap-icons.css";
import { IEnvironmentSettings } from "../../configuration/environmentSettings";
import { IEnvironmentBarStyles } from "../index";

type EnvironmentBarProps = {
    environmentSettings?: IEnvironmentSettings;
    styles?: IEnvironmentBarStyles;
};

export const EnvironmentBar = (props: EnvironmentBarProps) => {
    if (!props.environmentSettings?.displayEnvironmentBar) {
        return null;
    }

    return (
        <div className="d-flex align-items-center justify-content-center" style={props.styles?.environmentBar}>
            <span className="bi bi-exclamation-triangle-fill" style={props.styles?.environmentIcon} aria-hidden="true" />
            <span style={props.styles?.environmentText}>
                {props.environmentSettings?.environmentName} environment
            </span>
        </div>
    );
};